module.exports = __webpack_public_path__ + "static/media/5DPO6.7e493fec.jpg";